/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./Rave2bundlebar'], function(Rave2bundlebar) {
	'use strict';

	class Rave2bundlestackedbar extends Rave2bundlebar{
		constructor(){
			super();
		}

		get config(){
			const config = super.config;
			config.type = 'StackedBar';
			config.slotConfig = {
				'exclude': [
					'yStart'
				]
			};
			delete config['supportsForecasts'];

			//properties
			config.properties.stacked.defaultValue = true;
			delete config.properties['target.marker.color'];

			//slots
			config.slots.target = {
				'hidden': true
			};
			config.slots.color.stackValuesOnAxis = true;
			config.slots.color.useInTopBottomQueries = false;

			//include
			const forbidden = ['target.marker.color', 'target.marker.thickness'];
			config.config.include = config.config.include.filter(property => forbidden.indexOf(property) === -1);

			return config;
		}
	}

	return Rave2bundlestackedbar;
});